import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { forkJoin, map, Observable, of, switchMap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class GridFactory {
  GENERAL_CONFIG: any;

  constructor(private http: HttpClient) {
    this.GENERAL_CONFIG = environment;
  }

  getDataFromApi(url: string, params: any) {
    return this.http.get(this.GENERAL_CONFIG.base_url + url, { params });
  }

  postDataToApi(url: string, data: any) {
    const body = new FormData();
    _.map(data, (v: any, k: any) => {
      if (data[k] !== null && data[k] !== undefined) {
        body.append(k, v);
      }
    });
    return this.http.post(this.GENERAL_CONFIG.base_url + url, body);
  }

  loadGridData(url: string, params: any): Observable<any> {
    const parts: string[] = [];
    _.forEach(params, (v: any, k: string) => {
      if (v !== null && v !== undefined) {
        parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
      }
    });
    const body = parts.join('&');
    return this.http.post(url, body, {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
      }),
    });
  }

  loadFile(url: string): Observable<any> {
    return this.http.get(url);
  }

  loadGridDataSplit(url: string, filterArrays: any[]): Observable<any> {
    const requests = filterArrays.map((params: any) => this.loadGridData(url, params));
    return forkJoin(requests).pipe(
      map((results: any[]) => {
        if (!results.length) return { callSuccess: '0' };
        const base = results[0];
        const mergedData: any[] = [];
        results.forEach((r: any) => {
          if (r?.data) {
            mergedData.push(...r.data);
          }
        });
        base.data = mergedData;
        return base;
      })
    );
  }

  getDataUpdate(url: string, params: any): Observable<any> {
    return this.loadGridData(url, params);
  }
}
